import {http} from 'hiya-common/src/utils/axios'
import {formatTime2Arr} from 'hiya-common/src/utils'
import {HiyaVerHost} from 'hiya-common/src/constant'
import {channel_type_enum} from 'hiya-common/src/reducers/commonTypes'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'

export const markNum = (num) => {
  if (num === 0) {
    return 0
  }
  return num < 0 ? num : `+${Math.abs(num)}`
}
export const getSecTime = (sec) => {
  return formatTime2Arr(Number(sec) || 0, false)
}
// 获取相差天数
export const DifferenceDays = (startDate, endeDate) => {
  try {
    const dateStart = new Date(startDate.replace(/\./g, '/'))
    const dateEnd = new Date(endeDate.replace(/\./g, '/'))
    return ((dateEnd as any) - (dateStart as any)) / (1000 * 60 * 60 * 24)
  } catch (error) {
    // a
  }
  return 0
}

// 获得datestr
export const getDateStr = (date) => {
  return `${date.getFullYear()}.${
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
  }.${date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`}`
}

export const getHoursMin = (sec) => {
  if (!sec) {
    return '0min'
  }
  if (sec > 60 && sec < 3600) {
    return `${Math.floor(sec / 60)}min`
  }
  if (sec > 3600) {
    return Math.floor((sec % 3600) / 60) > 0
      ? `${Math.floor(sec / 3600)}h${Math.floor((sec % 3600) / 60)}min`
      : `${Math.floor(sec / 3600)}h`
  }
  return '0min'
}

export const retryDownload = ({
  resolve,
  reject,
  fileName,
  url,
  params,
  retryCnt = 20,
}) => {
  // 增加最高轮询次数
  // let retryCnt = retryCnt || 200
  // eslint-disable-next-line consistent-return
  const retry = async (uuid = '') => {
    // eslint-disable-next-line no-param-reassign
    retryCnt -= 1
    if (retryCnt < 0) {
      return reject()
    }
    try {
      const res = await http.post(url, {...params, uuid})
      if (res.data.data.done || res.data.data.url) {
        window.HiyaJSBridge.callHandler('openScheme', {
          url: `hiya://openWindow?external=1&need_user_info=0&url=${encodeURIComponent(
            res.data.data.url
          )}`,
        })
        return resolve(res)
      }

      setTimeout(() => {
        retry(res.data.data.uuid)
      }, 1000)
    } catch (err) {
      // onlyToast(err || err?.msg)
    }
  }
  retry()
}

export enum RefundDetailType {
  RecoverDiamond = 1,
  RecoverSalary = 2,
  RefundInfo = 3,
}

export enum AllRefundDetailCycle {
  ThisCycle = 1,
  PriorCycle = 2,
}

export enum RefundType {
  refund = 1,
  recoveries = 2,
}
// 账目类型
export enum DiamondAndSalaryKind {
  退款 = 1,
  回款 = 2,
}
// 钻石和薪资下退款和再充值tab数据是一样的，只是一个展示的是钻石一个是美元
export enum RefundAndRepayTab {
  钻石 = 1, // 1追回钻石列表
  薪资 = 2, // 2追回薪资列表
}

export const ColorType = {
  diamond: {
    [DiamondAndSalaryKind.退款]: 'orange',
    [DiamondAndSalaryKind.回款]: 'blue',
  },
  salary: {
    [DiamondAndSalaryKind.退款]: 'red',
    [DiamondAndSalaryKind.回款]: 'green',
  },
}

export const goRefundDetail = (params: {
  order_id: string
  id: number
  mid: number
  t_range: string
  kind: RefundAndRepayTab
}) => {
  const url = `${HiyaVerHost}/anchorcenter/RefundDetail`
  // otherInfo中必须包含order_id:string id:number mid:number  t_range:string kind

  window.HiyaJSBridge.callHandler('openScheme', {
    url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=1&other_info=${encodeURIComponent(
      JSON.stringify(params)
    )}&url=${url}`,
  })
}

export const goRefundList = (params: {mid?: number}) => {
  const url = `${HiyaVerHost}/anchorcenter/RefundList`
  // otherInfo中可以不包含mid 没有mid就使用deviceinfo中的h_m
  window.HiyaJSBridge.callHandler('openScheme', {
    url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=1&other_info=${encodeURIComponent(
      JSON.stringify(params)
    )}&url=${url}`,
  })
}
// 去往薪资钱包
export const goSalaryWallet = () => {
  const url = `${HiyaVerHost}/union/SalaryWallet`
  window.HiyaJSBridge.callHandler('openScheme', {
    url: `hiya://openWindow?fullscreen=1&external=0&need_user_info=1&url=${url}`,
  })
}

export enum AllRefundListPageType {
  All = 0,
  OverallSalary = 1,
  BaseSalary,
  RewardsAndPunishment,
  // Refund直接跳转另外一种类型的页面
}

export const goAllRefundList = (pageType: AllRefundListPageType) => {
  const url = `${HiyaVerHost}/anchorcenter/AllRefundList`

  return () => {
    window.HiyaJSBridge.callHandler('openScheme', {
      url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=1&other_info=${encodeURIComponent(
        JSON.stringify({pageType})
      )}&url=${url}`,
    })
  }
}

export enum unionStatusType {
  正常 = 1,
  退会 = 2,
}
export enum SalaryOverviewStatusType {
  当周期在会 = 1,
  当周期退会,
  前周期退会,
}
export const goAllRefundDetail = () => {
  const url = `${HiyaVerHost}/anchorcenter/AllRefundDetail`
  return () => {
    window.HiyaJSBridge.callHandler('openScheme', {
      url: `hiya://openWindow?fullscreen=0&external=0&need_user_info=1&url=${url}`,
    })
  }
}
// 假数据用于表格占位展示
export const member = {
  id: 11003451,
  isreg: 1,
  ct: 1648693017,
  rt: 1648693018,
  phone: '555400',
  name: '测试',
  gender: 1,
  sign: '',
  avatar: 4301535,
  cover: 0,
  region_code: '86',
  age: 28,
  isbind: 1,
  opentype: 0,
  iseverbind: 1,
  birth: 795474000,
  avatar_urls: {
    aspect_low: {
      urls: [
        'http://me-media-gateway.srv.test.ixiaochuan.cn/account/avatar/id/4301535/sz/228',
      ],
    },
    origin: {
      urls: [
        'http://me-media-gateway.srv.test.ixiaochuan.cn/account/view/id/4301535/sz/src',
      ],
    },
  },
  zyid: '11003451',
}
// 收款渠道中 不允许用户自助选中的渠道
export const noSelPayPaths = [
  channel_type_enum.转金币,
  channel_type_enum.转币商金币,
]
